import(/* webpackMode: "eager" */ "/codebuild/output/src3655684314/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
